import React, {useEffect} from "react";
import {useAppContext} from "./context/AppContext";
import NavigationBlock from "./components/NavigationBlock";
import TabSectionBlk from "./components/TabSectionBlk";
import FooterPage from "./components/FooterPage";
import IrisChatBotBlk from "./components/IrisChatBotBlk";
import {clientVertical} from "./data/clientverticals";
import {icxeedDifference} from "./data/icxeeddifference";
import HeroSectionBlk from "./components/HeroSectionBlk";
import UseCasesSectionBlk from "./components/UseCasesSectionBlk";
import CardSliderSectionBlk from "./components/CardSliderSectionBlk";
import TestimonialSectionBlk from "./components/TestimonialSectionBlk";
import KeyContactsSectionBlk from "./components/KeyContactsSectionBlk";
import AccordionSectionBlk from "./components/AccordionSectionBlk";
import AskIrisSectionBlk from "./components/AskIrisSectionBlk";

import {useCasesCards} from "./data/useCasesSlider";
import {useCaseCard} from "./data/caseStudySlider";
import {testimonials} from "./data/testimonials";
import {testimonialsAws} from "./data/testimonialsAws";
import LoginCard from "./components/LoginCard";

const App = () => {
  const {isLoggedIn, setIsLogin} = useAppContext();

  useEffect(() => {
    const storedLogin = localStorage.getItem("iris-portal-signed");
    if (storedLogin === "true") {
      setIsLogin(true);
    }
  }, [setIsLogin]);

  return (
    <React.Fragment>
      {!isLoggedIn ? (
        <LoginCard />
      ) : (
        <div className="iris-container-page">
          <NavigationBlock />
          <HeroSectionBlk />

          <div id="icxeed-difference">
            <TabSectionBlk title="iCXeed Difference" tabs={icxeedDifference} />
          </div>

          <div id="clientele-verticals">
            <TabSectionBlk
              title="Clientele & Verticals"
              tabs={clientVertical}
            />
          </div>

          <div id="use-cases">
            <UseCasesSectionBlk
              title="Use Cases / Battlecards"
              description="Explore iCXeed's essential battlecards - a curated set of use cases, best practice guides, and rapid-deployment solutions for CX, Contact Centre, and AI transformation."
              videoBg={true}
            />
            <CardSliderSectionBlk
              cards={(useCasesCards ?? []).map((c) => ({
                ...c,
                image: c.image ?? "",
              }))}
            />
            <UseCasesSectionBlk
              title="Case Studies"
              description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin sodales arcu vel sem pellentesque, quis pellentesque ligula scelerisque. Donec vitae metus nibh."
              videoBg={false}
            />
            <CardSliderSectionBlk cards={useCaseCard ?? []} />
          </div>
          <div id="client-testimonials">
            <TestimonialSectionBlk testimonials={testimonials} />
            <TestimonialSectionBlk testimonials={testimonialsAws} />
          </div>
          <div id="key-contacts">
            <KeyContactsSectionBlk />
            <AccordionSectionBlk />
          </div>
          <div id="ask-iris">
            <AskIrisSectionBlk />
            <IrisChatBotBlk />
          </div>

          <FooterPage />
        </div>
      )}
    </React.Fragment>
  );
};

export default App;
